module.exports = __webpack_public_path__ + "static/media/view5.cd4bdbe5.jpg";